import { UpdateTag } from 'components/tag/UpdateTag'

import React, { Dispatch, PropsWithChildren, SetStateAction } from 'react'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { VoiceGroupFactor } from 'service/list'
import { contentVideoFormValues } from 'utils/type'
import { UserVoiceDiv } from '../linkType/components/UserVoiceDiv'
import { PlanTag } from 'components/planTag'
import { Me } from 'service/user'
import { useNavigate } from 'react-router-dom'

interface UserVoiceListProps {
  watch: UseFormWatch<contentVideoFormValues>
  setValue: UseFormSetValue<contentVideoFormValues>
  control: Control<contentVideoFormValues, any>
  userVoiceList: VoiceGroupFactor[] | undefined
  userVoiceRefetch: any
  setVoiceName: Dispatch<SetStateAction<string>>
  userInfo: Me
}

export const UserVoiceList = ({
  watch,
  setValue,
  control,
  userVoiceList,
  userVoiceRefetch,
  setVoiceName,
  userInfo,
}: PropsWithChildren<UserVoiceListProps>) => {
  const navigate = useNavigate()
  return (
    <div className="flex flex-col  gap-4  bg-[#F1F8FF] p-4 rounded-[6px] border-[1px]">
      <div className="flex flex-col gap-3 md:items-start items-center">
        <div className="flex gap-2 items-start">
          <p className="font-bold text-[24px] text-left">내 목소리</p>
          <UpdateTag />
        </div>
        {/* <span>10문장만 녹음하면 내 목소리를 만들어드려요!</span>
        <p className="flex gap-1 items-center">
          <img src="assets/img/cash.png" alt="" className="w-[11px] h-[13px]" />
          <span className=" text-main">10,000 (최초 1회 무료 제작)</span>
        </p> */}
      </div>
      {/* 
      <button
        className="flex gap-2 items-center w-[240px] h-[54px] border-[1px] border-[#D9DEE8] rounded-[4px] px-4  disabled:opacity-30 bg-[white] "
        type="button"
        onClick={() => {
          setVoiceCloningModalOpen((prev) => !prev)
        }}
        disabled={!data}
      >
        {<PlanTag planName="PREMIUM" />}
        <span>{`🗣️ 내 목소리 만들기 >`}</span>
      </button> */}
      {userInfo?.subscriptions?.planId === 3 ? (
        <>
          {' '}
          <div className="grid md:grid-cols-2 grid-cols-1  gap-x-1 gap-y-2 md:pb-4">
            {userVoiceList?.map((voice, index) => {
              return (
                <Controller
                  key={voice.id || index} // 반드시 key 추가!
                  render={({ field }) => (
                    <UserVoiceDiv<contentVideoFormValues>
                      {...field}
                      id={index}
                      index={index}
                      setVoiceName={setVoiceName}
                      setValue={setValue}
                      watch={watch}
                      voice={voice}
                      userVoiceRefetch={userVoiceRefetch}
                    />
                  )}
                  name="userVoiceId"
                  control={control}
                />
              )
            })}
          </div>
        </>
      ) : (
        <>
          {' '}
          <div
            className="flex gap-3 items-center cursor-pointer"
            onClick={() => {
              navigate('/price-guide')
            }}
          >
            <PlanTag planName="PREMIUM" />
            <p>
              내 목소리를 생성하고 사용하려면{' '}
              <span className="font-bold">{"'상품 영상 프리미엄 플랜'"}</span>
              으로 업그레이드 해보세요 {`>>`}
            </p>
          </div>
        </>
      )}
    </div>
  )
}
